import styled from 'styled-components';

export const getCardGutter = (editing: boolean) => {
  return editing ? '30px' : '25px';
};

export const CardBodyContent = styled.div`
  padding-bottom: 17px;
  padding-top: 17px;
`;
